import { getEmployeeFullName } from '../../../../util/table.util'

// Helper function to get initials from employee name
export const getEmployeeInitials = (employee) => {
  const fullName = getEmployeeFullName(employee)
  if (!fullName) return '?'

  const names = fullName.trim().split(' ')
  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase()
  }
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase()
}

// Tab configuration
export const TABS = [
  { key: 'userproperties', label: 'User Properties' },
  { key: 'groups', label: 'Groups' },
  { key: 'licenses', label: 'Licenses' },
]
